import React, { useMemo } from 'react';
import useSWR from 'swr';
import { apiBaseURL } from '../../Utils/ProjectConstants';


export default function useFetchSupervisors() {

    // Fetch data using SWR, only if initialData is null
    const { data, error } = useSWR(`${apiBaseURL}/api/users/research`, {
        dedupingInterval: 300000,
    });

    // Map data to desired format
    const allSupervisors = useMemo(() => {
        return data?.map((x) => ({
            label: `${x.firstName} ${x.lastName}`,
            value: x.id,
        }))
    }, [data]);
    
    return {
        allSupervisors,
        error,
        isLoading: !data && !error,
    }
}